<template>
  <ProductPageLayout
    name="芊荨压缩"
    :logo="logo"
    :hero-image="heroImage"
    lead="高效、稳定、轻量的压缩解压工具，覆盖办公资料归档、批量传输与跨设备分享场景。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/mtyzip/MtyZipSetup.exe"
    download-file-name="MtyZipSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="压缩、解压、预览与专项压缩，让文件传输与归档更高效。"
    other-desc="更多压缩能力，覆盖 PDF、视频与大文件分卷等场景。"
    reviews-desc="真实反馈持续驱动压缩工具体验优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'Compress',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/mtyzip/ziplogo48.png'),
      heroImage: require('@/assets/mtyzip/首页.png'),
      featureLines: [
        '文件压缩 / 文件解压 / 批量打包 / 压缩预览',
        'PDF压缩 / 图片压缩 / 视频压缩 / 大文件分卷'
      ],
      metaItems: [
        { icon: 'fast', label: '极速压缩' },
        { icon: 'lock', label: '安全可靠' },
        { icon: 'puzzle', label: '功能丰富' }
      ],
      detailedFeatures: [
        {
          title: '文件压缩',
          brief: '多格式压缩一键完成，速度与体积控制更平衡。',
          detail: '支持常见压缩格式，能够快速打包文档、素材与项目文件，减少传输和存储成本。',
          image: require('@/assets/mtyzip/文件压缩界面.jpg')
        },
        {
          title: '文件解压',
          brief: '复杂压缩包也能稳定解压，过程清晰可控。',
          detail: '针对多层目录、批量解压和大文件做了处理优化，减少中断和失败，提升日常办公效率。',
          image: require('@/assets/mtyzip/文件解压过程.jpg')
        },
        {
          title: '图片压缩',
          brief: '图片体积更小，清晰度保持更好。',
          detail: '提供压缩级别调节，便于兼顾画质与体积，适合文档上传、网页素材和消息分发场景。',
          image: require('@/assets/mtyzip/图片压缩界面.jpg')
        },
        {
          title: '压缩预览',
          brief: '无需完整解压即可查看压缩包内容。',
          detail: '预览结构更直观，快速定位目标文件，减少重复解压步骤，提升操作流畅度。',
          image: require('@/assets/mtyzip/主界面.jpg')
        }
      ],
      otherFeatures: [
        { title: 'PDF 压缩', description: '减小 PDF 体积，便于邮件与在线提交。', icon: 'pdf' },
        { title: '视频压缩', description: '在清晰度可控前提下显著降低视频大小。', icon: 'video' },
        { title: '分卷压缩', description: '大文件可拆分为多卷，跨设备传输更方便。', icon: 'puzzle' },
        { title: '批量任务', description: '多个目录并发处理，节省重复操作时间。', icon: 'iterate' }
      ],
      reviews: [
        { name: '梁经理', comment: '资料归档效率提升明显，批量压缩稳定性很好。', avatar: require('@/assets/mtyzip/avatar1.jpeg') },
        { name: '马老师', comment: '课件和录屏素材统一打包后，分享给学生方便很多。', avatar: require('@/assets/mtyzip/avatar2.jpeg') },
        { name: '曹同学', comment: '解压速度很快，界面简单，几乎不用学习就能上手。', avatar: require('@/assets/mtyzip/avatar3.jpeg') },
        { name: '彭运营', comment: '活动素材很多时，分卷压缩功能帮了大忙。', avatar: require('@/assets/mtyzip/avatar4.jpeg') },
        { name: '沈产品', comment: '常用格式覆盖够全，内部协作传文件更省心。', avatar: require('@/assets/mtyzip/avatar5.jpeg') },
        { name: '苏设计', comment: '图片压缩画质保持不错，交付素材更高效。', avatar: require('@/assets/mtyzip/avatar6.jpeg') }
      ]
    }
  }
}
</script>
